<template>
  <div :class="tooltip">
    <p>
      В пароле должно быть
      <strong>как минимум:</strong>
    </p>
    <ul>
      <li class="mb-2">
        <v-icon v-if="ismin" class="pw-check" size="14px" color="#8cbf26">mdi-check-circle</v-icon
        ><span v-else class="pw-list-marker"></span>
        6 символов (без пробелов и букв русского алфавита)
      </li>
      <li class="mb-2">
        <v-icon v-if="isupper" class="pw-check" size="14px" color="#8cbf26">mdi-check-circle</v-icon
        ><span v-else class="pw-list-marker"></span>одна заглавная латинская буква
      </li>
      <li class="mb-2">
        <v-icon v-if="islower" class="pw-check" size="14px" color="#8cbf26">mdi-check-circle</v-icon
        ><span v-else class="pw-list-marker"></span>одна строчная латинская буква
      </li>
      <li class="mb-2">
        <v-icon v-if="isdigit" class="pw-check" size="14px" color="#8cbf26">mdi-check-circle</v-icon
        ><span v-else class="pw-list-marker"></span>одна цифра
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "PwdTip",
  props: {
    ismin: Boolean,
    isupper: Boolean,
    islower: Boolean,
    isdigit: Boolean,
    value: Boolean,
    position: {
      default: "right",
      type: "right" | "top",
    },
  },

  computed: {
    tooltip() {
      return {
        hide: !this.value,
        tooltip: true,
        "tooltip--right": this.position === "right",
        "tooltip--top": this.position === "top",
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.hide {
  display: none;
}
.tooltip {
  z-index: 9999999999;
  padding: 12px;
  background-color: #ffffff;
  position: absolute;
  width: 280px;
  filter: drop-shadow(0px 6px 16px rgba(34, 39, 51, 0.12));
  font-size: 12px;
  line-height: 17px;

  &--right {
    left: calc(100% + 20px);
  }

  &--top {
    bottom: calc(100% + 10px);
  }

  ul {
    list-style: none;
  }

  li {
    position: relative;
  }

  .pw-check {
    position: absolute;
    left: -20px;
    top: 1px;
  }
  .pw-list-marker {
    position: absolute;
    left: -15px;
    top: 6px;
    display: block;
    width: 4px;
    height: 4px;
    background: #000000;
    border-radius: 50%;
  }
}
</style>
